import { Component, Inject, Injector, OnInit } from '@angular/core';
import { CoreAbstractComponent } from '../../../core/core-abstract.component';
import { DOCUMENT } from '@angular/common';
import { ICoreExtendedComponentOptions } from '../../../core/interfaces/core.interfaces';
import { environment } from '../../../../environments/environment';
import { CoreTableSortDirectionEnum, CoreTableSortState } from '../../../core/models/table-sort';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CoreService } from '../../../core/service/core.service';
import { BehaviorSubject } from 'rxjs';
import { EDownloadableFile } from '../../../core/models/printportal';
import { SpLevel, SpLevelsor } from '../../../core/entity/printportal';

export class ComponentSearch {
  nyomda?: number; // orm reláció van, tehát a nyomda_id nem létező mező a backend oldalon!
}

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrl: './offer.component.scss'
})
export class OfferComponent  extends CoreAbstractComponent implements OnInit {

  override validScopes: string[] = ['pp:access']

  public override componentList: BehaviorSubject<SpLevel[]>;

  public componentItemSelected: SpLevel = new SpLevel();

  // a signalból lehúzzuk a state-t
  public scrollParam = this.coreService.scrollParamsState();

  constructor(
    private injector: Injector,
    @Inject(DOCUMENT) private document: Document    
    ) {

      super(injector, document);

      const options: ICoreExtendedComponentOptions = {
        dataTableOptions: {
          fetchUrl: `${environment.endpoints.app}/level-v2/${this.coreService.getNyomdaId()}`,
          // FONTOS itt nem id van hanem kód
          primaryKey: 'kod',
          // FONTOS kelt alapján sortolunk
          sort: 'kelt',
          // FONTOS desc, tehát legutolsó elől
          direction: 'desc',
          // FONTOS több táblát is tervezünk
          name: 'offer-list'
        }
      }
  
      this.componentOptions = options;
      this.preAuth();
  }

  ngOnInit(): void {

    /**
     * Minden származtatott komponensünket inicializálnunk kell, ha a komponens szintű szolgáltatásokat automatikusan igénybe akarjuk venni.
     * A preInitComponent kezelni nekünk az activeRoute-n keresztül beérkező ID paramétereket, beállítja a tábla rendezést, lapozást és 
     * az egyéb listázással kapcsolatos dolgainkat.
     */
    this.preInitComponent<SpLevel>();

    /**
     * Regisztrálnunk kell a keresőhöz tartozó objektumunkat is
     */
    this.setComponentSearch(new ComponentSearch());

    this.componentSearchOptions = {
      paramsVersion: 1,
      // virtualTextField: 'search_text',
      // virtualFields: ['from_address','recipient','subject']
    }

    /**
     * A rendezésünk alapértelmezéseit állítjuk be legelőször.
     */
    this.tableSort.setColumn('kelt').setDirection(CoreTableSortDirectionEnum.DESC);

    /**
     * Alapértelmezett komponens kereső űrlapunk deklarációja
     */
    this.componentSearchForm = new UntypedFormGroup({
      search_text: new UntypedFormControl()
    });

  }

  public onSelectComponentItem(event: SpLevel): void {
    this.componentItemSelected = event;
  }

  public onSortChanged(event: CoreTableSortState): void {
    this.sortSubject.next(event);
  }

  public onSearch(): void {
    super.componentSearchSubmit<ComponentSearch>();
  }

  public onSearchReset(): void {
    super.componentSearchReset<ComponentSearch>(new ComponentSearch());
  }

}
